const e = "focus-trap.focus-after-trapped", s = "focus-trap.focus-after-released", c = "focus-trap.focusout-prevented", t = {
  cancelable: !0,
  bubbles: !1
}, E = {
  cancelable: !0,
  bubbles: !1
}, o = "focusAfterTrapped", _ = "focusAfterReleased", T = /* @__PURE__ */ Symbol("elFocusTrap");
export {
  c as FOCUSOUT_PREVENTED,
  E as FOCUSOUT_PREVENTED_OPTS,
  s as FOCUS_AFTER_RELEASED,
  e as FOCUS_AFTER_TRAPPED,
  t as FOCUS_AFTER_TRAPPED_OPTS,
  T as FOCUS_TRAP_INJECTION_KEY,
  _ as ON_RELEASE_FOCUS_EVT,
  o as ON_TRAP_FOCUS_EVT
};
